import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PasswordIcon(props: IconProps) {
    return <Icon {...props} iconKey={"password"}/>
}
